import { isProductionHost } from 'Lib/hosts'

// Convenience flag to detect dev and staging environments
window.__DEV__ = !isProductionHost()

// Convenience flag to detect app running locally (includes LAN IP for phone testing)
window.__LOCAL_DEV__ = location.hostname === 'localhost' || location.hostname.startsWith('192.168.')

export {}
